<template>
  <div
    class="noWrap"
  >
    {{ getValue }}
  </div>
</template>

<script>
import CpfFilter from 'Arch/filters/CpfFilter';
import CnpjFilter from 'Arch/filters/CnpjFilter';

export default {
  name: 'DataTableCpfCnpjColumn',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    isCpf() {
      return this.value && this.value.length === 11;
    },
    getValue() {
      return this.handleColumnValue(
        this.formatValue,
      );
    },
    formatValue() {
      return this.isCpf
        ? CpfFilter(
          this.value,
        )
        : CnpjFilter(
          this.value,
        );
    },
  },
  inject: {
    handleColumnValue: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
